class LazyAutoplayVideo extends HTMLVideoElement {
  constructor() {
    super()

    // Check for reduced motion preference
    this.prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    )

    // Options for the observer (which margins to apply)
    const options = {
      root: null,
      rootMargin: '300px 0px 300px 0px', // 300px margin vertically
      threshold: 0,
    }

    // Create an intersection observer instance
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.tryPlay()
        } else {
          this.pause()

          if (this.alwaysRestart) {
            this.currentTime = 0
          }
        }
      })
    }, options)
  }

  /**
   * Attempt to play the video, respecting prefers-reduced-motion
   * and handling autoplay restrictions gracefully
   */
  tryPlay() {
    // Respect prefers-reduced-motion preference
    if (this.prefersReducedMotion.matches) {
      return
    }

    // Attempt to play with error handling for autoplay restrictions
    const playPromise = this.play()
    if (playPromise !== undefined) {
      playPromise.catch((error) => {
        // Autoplay was prevented - this is expected in some browsers
        // The video will show the first frame as a fallback
        if (error.name !== 'AbortError') {
          console.warn('Video autoplay was prevented:', error.message)
        }
      })
    }
  }

  /**
   * Handle changes to the prefers-reduced-motion preference
   */
  handleReducedMotionChange = (event) => {
    if (event.matches) {
      // User now prefers reduced motion - pause the video
      this.pause()
    }
  }

  connectedCallback() {
    // Start observing the video element
    this.observer.observe(this)
    this.alwaysRestart = this.getAttribute('data-always-restart')

    // Listen for changes to reduced motion preference
    this.prefersReducedMotion.addEventListener(
      'change',
      this.handleReducedMotionChange
    )
  }

  disconnectedCallback() {
    // Stop observing the video element
    this.observer.unobserve(this)

    // Clean up reduced motion listener
    this.prefersReducedMotion.removeEventListener(
      'change',
      this.handleReducedMotionChange
    )
  }
}

// Define the custom element
customElements.define('lazy-autoplay-video', LazyAutoplayVideo, {
  extends: 'video',
})
